import { PaneComponent } from './pane/pane.component';

export const Components = [
	PaneComponent,
];
